import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import Button from '@mui/material/Button';
import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import { Alert } from '@/common/components/alert/Alert';
import { AlertSeverity, severityConfig } from '@/common/components/alert/config.tsx';
import { useTheme } from '@mui/material/styles';
import { ModalOptions } from '@/common/components/modal-provider/types.ts';

export interface AlertOptions {
  severity: AlertSeverity;
  title: ReactNode;
  message?: ReactNode;
  secondaryMessage?: ReactNode;
  acknowledgeLabel?: ReactNode;
  maxWidth?: ModalOptions<unknown>['maxWidth'];
}

export const useAlert = () => {
  const showModal = useModal();
  const theme = useTheme();

  const showAlert = (options: AlertOptions) => {
    const { severity, title, message, secondaryMessage, acknowledgeLabel, maxWidth } = options;

    return showModal<void>({
      content: ({ resolve }) => (
        <Alert
          severity={severity}
          title={title}
          message={message}
          secondaryMessage={secondaryMessage}
          actions={
            <Button variant="contained" fullWidth onClick={() => resolve()}>
              {acknowledgeLabel ?? <Trans>OK</Trans>}
            </Button>
          }
          sx={{ p: 3 }}
        />
      ),
      sx: {
        borderTop: `4px ${theme.palette[severityConfig[severity].color].main} solid`,
      },
      maxWidth,
    });
  };

  return showAlert;
};
